import { ReferenceSection } from "../../common";

export enum CardMarkupViewerState {
    OnlyQuestion = "OnlyQuestion",
    QuestionAndHint = "QuestionAndHint",
    QuestionAndAnswer = "QuestionAndAnswer",
    Full = "Full",
}

export interface CardMarkupViewerProps {
    cardId?: string;
    markup: string;
    state: CardMarkupViewerState;
    showSeparators?: boolean;
    // The {reference} block lives at the card level. When a single subcard is
    // shown (Memorizer / multicard review) the markup passed in is synthetic and
    // has no reference, so the card's reference is supplied explicitly here.
    referenceOverride?: ReferenceSection[];
    // Per-subcard review stats keyed by subcardKey(question, answer). When given,
    // each rendered subcard shows an accuracy badge.
    subcardStats?: Record<string, { correct: number; total: number }>;
    // Show the {reference} table expanded instead of collapsed (used in review).
    expandReference?: boolean;
}
